import { render, staticRenderFns } from "./OrderAddressValidationStatus.vue?vue&type=template&id=105d74b3&"
import script from "./OrderAddressValidationStatus.vue?vue&type=script&lang=js&"
export * from "./OrderAddressValidationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports